import { render, staticRenderFns } from "./fengche.vue?vue&type=template&id=1287fa7a&scoped=true&"
import script from "./fengche.vue?vue&type=script&lang=js&"
export * from "./fengche.vue?vue&type=script&lang=js&"
import style0 from "./fengche.vue?vue&type=style&index=0&id=1287fa7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1287fa7a",
  null
  
)

export default component.exports